<template>
  <PricingBanner v-if="Object.keys(pricingBannerData).length" :data="pricingBannerData" />
  <div class="py-16 px-4 xl:px-0 bg-[#f7ecdf]">
    <ComparisonPricing v-if="Object.keys(comparisonData).length" :data="comparisonData" />
    <div class="max-w-7xl mx-auto">
      <StepsHowItWorks v-if="Object.keys(stepsSectionData).length" :data="stepsSectionData" />
    </div>
    <FaqSection v-if="Object.keys(faqSectionData).length" :data="faqSectionData" />
  </div>
</template>

<script setup lang="ts">
import PricingBanner from '@/components/modules/event-pricing/PricingBanner.vue'
import ComparisonPricing from '@/components/modules/event-pricing/ComparisonPricing.vue'
import { useDynamicTranslations } from '@/i18n'
import { ref, watchEffect } from 'vue'
import StepsHowItWorks from '@/components/modules/howitworks/StepsHowItWorks.vue'
import FaqSection from '@/components/modules/home/FaqSection.vue'
import { useHead } from '@vueuse/head'
import { eventPricingMeta } from '@/config/meta'

useHead(eventPricingMeta)

const pricingBannerData = ref({})
const comparisonData = ref({})
const stepsSectionData = ref({})
const faqSectionData = ref({})
const { loadData } = useDynamicTranslations()

watchEffect(async () => {
  pricingBannerData.value = await loadData('pricingBanner')
  comparisonData.value = await loadData('comparisonPackage')
  stepsSectionData.value = await loadData('stepsSection')
  faqSectionData.value = await loadData('faqSection')
})
</script>
